import { Dialog, Transition } from '@headlessui/react';
import { Field, Form, Formik } from 'formik';
import { Fragment, useEffect } from 'react';
import * as Yup from "yup";
import { useDispatch, useSelector } from 'react-redux';
import { getActiveProjects, setEditModal, setSelectedManagers, setSelectedUsers, setSelectedViewers } from "../../../store/slices/projects";
import { addUserBodyCreate } from '../../globle-component/globle';
import { loadingHide, loadingShow } from '../../../helper/loading';
import { addMemberToProject, editProject } from '../../../services/projects';
import { notifySuccess } from '../../../helper/notification-helper';
import ListBox from './listBox';

const organizationId = localStorage.getItem('organizationID');

const formSchema = Yup.object().shape({
    projectName: Yup.string().required("Required"),
});

const EditProjectModal = ({ CustomInputComponent, CustomTextareaComponent }) => {
    const dispatch = useDispatch();
    const {
        editModal,
        initialModal,
        selectedManagers,
        selectedUsers,
        selectedViewers
    } = useSelector((state) => state.projects)
    const { activeMemberList: activeMembersList } = useSelector((state) => state.members)


    function closeModal() {
        dispatch(setEditModal(initialModal))
    }

    const selectAllManagers = () => { dispatch(setSelectedManagers(activeMembersList)); dispatch(setSelectedUsers([])); dispatch(setSelectedViewers([])); }
    const selectAllUsers = () => { dispatch(setSelectedUsers(activeMembersList)); dispatch(setSelectedManagers([])); dispatch(setSelectedViewers([])); }
    const selectAllViewers = () => { dispatch(setSelectedViewers(activeMembersList)); dispatch(setSelectedManagers([])); dispatch(setSelectedUsers([])); }

    const clearAllManagers = () => { dispatch(setSelectedManagers([])); }
    const clearAllUsers = () => { dispatch(setSelectedUsers([])); }
    const clearAllViewers = () => { dispatch(setSelectedViewers([])); }


    function clearModalData() {
        dispatch(setEditModal(initialModal));
        dispatch(setSelectedManagers([]));
        dispatch(setSelectedUsers([]));
        dispatch(setSelectedViewers([]));
    }

    useEffect(() => {
        setAssignUsersArray();
    }, [editModal])


    function setAssignUsersArray() {
        let manages = [];
        editModal.formData.managers.forEach(managerId => {
            const manager = activeMembersList.filter(item => item.id === managerId);
            if(manager.length > 0){manages.push(manager[0])}
        });


        let users = [];
        editModal.formData.users.forEach(userId => {
            const user = activeMembersList.filter(item => item.id === userId);
            if(user.length > 0){users.push(user[0])}

        });

        let viewers = [];
        editModal.formData.viewers.forEach(viewerId => {
            const viewer = activeMembersList.filter(item => item.id === viewerId);
            if(viewer.length > 0){viewers.push(viewer[0])}

        });

        console.log(editModal);
        console.log(manages);
        console.log(users);
        console.log(viewers);

        dispatch(setSelectedManagers(manages))
        dispatch(setSelectedUsers(users))
        dispatch(setSelectedViewers(viewers))

    }

    return (
        <>
            {editModal.modals.show  && editModal.modals.type === 'edit' ? (
                <Transition appear show={editModal.modals.show} as={Fragment}>
                    <Dialog
                        as="div"
                        className="fixed inset-0 z-[1000] overflow-y-auto bg-gray-500/40"
                        onClose={closeModal}
                    >
                        <div className="min-h-screen px-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <Dialog.Overlay className="fixed inset-0" />
                            </Transition.Child>

                            <span className="inline-block h-screen" aria-hidden="true">
                                &#8203;
                            </span>
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <div className="modal-loading inline-block z-[1000] w-full max-w-md p-6 my-8  text-left align-middle transition-all transform bg-white drop-shadow-2xl rounded-2xl">
                                    <Dialog.Title
                                        as="h3"
                                        className="ht-modal-header"
                                    >
                                        Edit Project
                                    </Dialog.Title>
                                    <Formik
                                        initialValues={{
                                            projectName: editModal.formData.name,
                                            projectDescription: editModal.formData.description,
                                        }}
                                        validationSchema={formSchema}
                                        onSubmit={(values) => {

                                            let managerIds = selectedManagers.map(a => a.id);
                                            let userIds = selectedUsers.map(a => a.id);
                                            let viewerIds = selectedViewers.map(a => a.id);

                                            var projectObject = {
                                                id: editModal.formData.id,
                                                name: values.projectName,
                                                description: values.projectDescription,
                                                record_activity: true,
                                                start_date: new Date().toISOString().split("T")[0],
                                                status: 1,
                                            };

                                            let body = [
                                                ...addUserBodyCreate(managerIds, 100),
                                                ...addUserBodyCreate(userIds, 101),
                                                ...addUserBodyCreate(viewerIds, 102),
                                            ];

                                            loadingShow('.modal-loading');
                                            editProject(projectObject).then((response) => {

                                                addMemberToProject(body, projectObject.id).then(
                                                    (res) => {
                                                        if (res.code === 201) {
                                                            notifySuccess("Project edited successfully");
                                                            dispatch(getActiveProjects(organizationId))
                                                            loadingHide('.modal-loading');
                                                            clearModalData()
                                                        }
                                                    }
                                                );
                                            });

                                        }}
                                    >
                                        {({ errors, touched, setFieldValue }) => (
                                            <Form>
                                                <div className="mt-2">
                                                    <div className="relative flex-auto">
                                                        <div className="flex flex-wrap p-3">
                                                            <ul
                                                                className="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4"
                                                                id="tabs-tab"
                                                                role="tablist"
                                                            >
                                                                <li
                                                                    className="nav-item"
                                                                    role="presentation"
                                                                >
                                                                    <a
                                                                        href="#add-new-general"
                                                                        className={
                                                                            "nav-link block leading-tight uppercase border-x-0 border-t-0 border-b-2 border-transparent px-6 py-3 my-2 hover:border-transparent hover:bg-gray-100 focus:border-transparent" + (editModal.modals.tab === 1 ? " active" : "")
                                                                        }
                                                                        id="add-new-general-tab"
                                                                        data-bs-toggle="pill"
                                                                        data-bs-target="#add-new-general"
                                                                        role="tab"
                                                                        aria-controls="add-new-general"
                                                                        aria-selected="true"
                                                                    >
                                                                        General
                                                                    </a>
                                                                </li>
                                                                <li
                                                                    className="nav-item"
                                                                    role="presentation"
                                                                >
                                                                    <a
                                                                        href="#add-new-member"
                                                                        className={
                                                                            "nav-link block leading-tight uppercase border-x-0 border-t-0 border-b-2 border-transparent px-6 py-3 my-2 hover:border-transparent hover:bg-gray-100 focus:border-transparent" + (editModal.modals.tab === 2 ? " active" : "")
                                                                        }
                                                                        id="add-new-member-tab"
                                                                        data-bs-toggle="pill"
                                                                        data-bs-target="#add-new-member"
                                                                        role="tab"
                                                                        aria-controls="add-new-member"
                                                                        aria-selected="false"
                                                                    >
                                                                        Members
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                            <div
                                                                className="tab-content w-full"
                                                                id="tabs-tabContent"
                                                            >
                                                                <div
                                                                    className={"tab-pane fade" + (editModal.modals.tab === 1 ? " show active" : "")}
                                                                    id="add-new-general"
                                                                    role="tabpanel"
                                                                    aria-labelledby="add-new-general-tab"
                                                                >
                                                                    <div className="mb-3">
                                                                        <label className="block uppercase tracking-wide text-gray-700 mb-2">
                                                                            Name{" "}
                                                                            <label className="text-red-700 mb-2">
                                                                                *
                                                                            </label>
                                                                        </label>
                                                                        <Field
                                                                            name="projectName"
                                                                            placeholder="Project Name"
                                                                            as={CustomInputComponent}
                                                                        />
                                                                        {errors.projectName &&
                                                                            touched.projectName ? (
                                                                            <p className="text-red-500 italic mb-3">
                                                                                {errors.projectName}
                                                                            </p>
                                                                        ) : null}
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <label className="block uppercase tracking-wide text-gray-700 mb-2">
                                                                            Description
                                                                        </label>
                                                                        <Field
                                                                            name="projectDescription"
                                                                            placeholder="Project Description"
                                                                            as={CustomTextareaComponent}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className={"tab-pane fade" + (editModal.modals.tab === 2 ? " show active" : "")}
                                                                    id="add-new-member"
                                                                    role="tabpanel"
                                                                    aria-labelledby="add-new-member-tab"
                                                                >
                                                                    <div className="mb-7">

                                                                        <div className='right'>
                                                                            <span className='cursor-pointer hover:underline px-1' onClick={selectAllManagers}>Select All</span>
                                                                            <span className='text-gray-400 text-[10px] px-1'>|</span>
                                                                            <span className='cursor-pointer hover:underline px-1' onClick={clearAllManagers}>Clear</span>
                                                                        </div>

                                                                        <label className="block uppercase tracking-wide text-gray-700 ">
                                                                            Manager
                                                                        </label>
                                                                        <p className=" text-gray-500">
                                                                            Oversees and manages the project
                                                                        </p>
                                                                        <ListBox
                                                                            selectedPeople={selectedManagers}
                                                                            setSelectedPeople={setSelectedManagers}
                                                                        />
                                                                    </div>
                                                                    <div className="mb-7">

                                                                        <div className='right'>
                                                                            <span className='cursor-pointer hover:underline px-1' onClick={selectAllUsers}>Select All</span>
                                                                            <span className='text-gray-400 text-[10px] px-1'>|</span>
                                                                            <span className='cursor-pointer hover:underline px-1' onClick={clearAllUsers}>Clear</span>
                                                                        </div>

                                                                        <label className="block uppercase tracking-wide text-gray-700">
                                                                            user
                                                                        </label>
                                                                        <p className=" text-gray-500">
                                                                            Works on the project, will not see
                                                                            other users (most common)
                                                                        </p>

                                                                        <ListBox
                                                                            selectedPeople={selectedUsers}
                                                                            setSelectedPeople={setSelectedUsers}
                                                                        />
                                                                    </div>
                                                                    <div className="mb-7">

                                                                        <div className='right'>
                                                                            <span className='cursor-pointer hover:underline px-1' onClick={selectAllViewers}>Select All</span>
                                                                            <span className='text-gray-400 text-[10px] px-1'>|</span>
                                                                            <span className='cursor-pointer hover:underline px-1' onClick={clearAllViewers}>Clear</span>
                                                                        </div>

                                                                        <label className="block uppercase tracking-wide text-gray-700 mb-0">
                                                                            Viewer
                                                                        </label>
                                                                        <p className=" text-gray-500">
                                                                            Can view the project, reports but
                                                                            not edit or comment
                                                                        </p>

                                                                        <ListBox
                                                                            selectedPeople={selectedViewers}
                                                                            setSelectedPeople={setSelectedViewers}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="flex items-center justify-end pt-3">
                                                                    <button
                                                                        className="ht-btn-black"
                                                                        type="button"
                                                                        onClick={closeModal}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                    <button
                                                                        className="ht-btn-yellow"
                                                                        type="submit"
                                                                    >
                                                                        Save
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </Transition.Child>
                        </div>
                    </Dialog>
                </Transition>
            ) : null}
        </>
    );

}

export default EditProjectModal;